import _ from 'lodash';

import { updateState } from '../../state';

import { cleanup } from './cleanup';

export function cleanUpdate(state, newState) {
  const molIndex = state.mouse.molIndex;
  const mergeState = updateState(state, newState);

  if (!newState.mols) {
    return mergeState;
  }

  const needsCleanup = newState.mols[molIndex] != null && !_.isEqual(state.mols[molIndex], newState.mols[molIndex]);
  if (needsCleanup) {
    return cleanup(mergeState);
  }

  return mergeState;
}
